<div
  class="container-fluid"
  [class.ui-search__wrap]="ui"
  [class.is-embedded]="embedded"
>
  <div class="p-relative">
    <div
      class="inputPosition"
      [ngClass]="{
        'z-index-500':
          (recipeData?.length || productData?.length || notfound) &&
          focus &&
          searchInput.value
      }"
    >
      <div class="input-group search-box" [class.ui-search]="ui">
        <!-- bg-white is a Bootstrap utility and carries !important, so it would
             paint a white tile over the themed field – legacy variant only -->
        <span
          class="input-group-text border-end-0"
          [class.bg-white]="!ui"
          [class.ui-search__icon]="ui"
        >
          <span *ngIf="!isLoading && !ui">
            <i class="fas fa-search"></i>
          </span>
          <svg
            *ngIf="!isLoading && ui"
            class="ui-search__glyph"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="7" />
            <path d="M20 20l-3.5-3.5" />
          </svg>

          <span
            class="spinner spinner-border spinner-border-sm"
            *ngIf="isLoading"
          ></span>
        </span>
        <input
          #searchField
          type="text"
          class="form-control form-control-lg border-start-0"
          [class.border-end-0]="embedded"
          [class.ui-search__input]="ui"
          [placeholder]="
            vehiclesBrand
              ? 'Search by make or model...'
              : 'Search for dishes, cuisines...'
          "
          (input)="searchProducts($event)"
          ngModel
          #searchInput="ngModel"
          (focus)="onFocus()"
          (click)="onFocus()"
        />
        <!-- embedded (phone sheet): trailing text add-on — "Clear" while there
             is text (keeps the sheet open), "Cancel" once it is empty -->
        <button
          *ngIf="embedded"
          type="button"
          class="input-group-text border-start-0"
          [class.bg-white]="!ui"
          [class.ui-search__close]="ui"
          (click)="clearOrClose()"
        >
          {{ searchInput.value ? "Clear" : "Cancel" }}
        </button>
      </div>
      <!-- <div
        class="border border-1 d-flex justify-content-center align-items-center bg-white"
      >
        <span class="ms-1">
          <i class="fa fa-search text-secondary" aria-hidden="true"></i>
        </span>
        <input
          type="search"
          class="searchInput form-control form-control-lg border-0 shadow-none w-93"
          name="search"
          id="search"
          (input)="searchProducts($event)"
          placeholder="Search for dishes, cuisines..."
          ngModel
          #searchInput="ngModel"
          (focus)="onFocus()"
        />
      </div> -->
    </div>
    <div
      #results
      class="resultsBox mt-1"
      [class.ui-search__results]="ui"
      *ngIf="
        (recipeData?.length || productData?.length || notfound) &&
        focus &&
        searchInput.value
      "
    >
      <p
        class="text-danger text-center"
        [class.ui-search__msg]="ui"
        *ngIf="searchResult"
      >
        {{ searchResult }}
      </p>
      <app-new-recipe-card
        [recipes]="recipeData"
        [compact]="embedded"
        *ngIf="newRecipeCards"
      ></app-new-recipe-card>
      <!-- embedded (phone sheet): text-only rows, like the new card's phone
           layout — the legacy card's fixed 150px photo overflowed the sheet -->
      <app-recipe
        [recipes]="recipeData"
        [showImage]="!embedded"
        *ngIf="!newRecipeCards"
      ></app-recipe>

      <div *ngIf="vehiclesBrand">
        <app-car-listing
          [product]="product"
          *ngFor="let product of productData"
        ></app-car-listing>
      </div>

      <div *ngIf="partsBrand">
        <app-store-product
          [products]="productData"
          [showDetails]="true"
        ></app-store-product>
      </div>

      <div *ngIf="!vehiclesBrand && !partsBrand">
        <app-responsive-grid-style
          [products]="productData"
        ></app-responsive-grid-style>
      </div>
    </div>
    <!-- click-away scrim behind the results (desktop); an embedded search
         sits inside its host's scrim already, so none here -->
    <div
      class="overlay"
      [class.ui-search__scrim]="ui"
      *ngIf="
        !embedded &&
        (recipeData?.length || productData?.length || notfound) &&
        focus &&
        searchInput.value
      "
      (click)="onBlur()"
      (wheel)="$event.preventDefault()"
    ></div>
  </div>
</div>
